(function () {
    "use strict";

    cip_StatusCommentDialog.id = function () {
        return 'commentDialog';
    };

    cip_StatusCommentDialog.title = function () {
        return 'Add Comment';
    };

    cip_StatusCommentDialog.width = function () {
        return 450;
    };

    cip_StatusCommentDialog.content = function () {
        return '<label>' +
            '<textarea class="text" type="text" name="commentDetail">' +
            '</textarea>' +
            '</label>';
    };

    cip_StatusCommentDialog.firstOpen = function () {
    };

    cip_StatusCommentDialog.success = function () {
    };

    cip_StatusCommentDialog.unpopulate = function () {
        return $('#' + cip_StatusCommentDialog.id() + " textarea[name=commentDetail]").getValue();
    };
})();